/**
 * Bilingual content bundle for the public site.
 * Phase 2A v2 — light corporate direction.
 */
export const messages = {
  ja: {
    nav: {
      home: "ホーム",
      about: "会社情報",
      services: "運営サービス",
      whoWeServe: "支えるお客様",
      customers: "支えるお客様",
      approach: "私たちの取り組み",
      ecosystem: "エコシステム",
      whatsNew: "最新情報",
      roadmap: "ロードマップ",
      testimonials: "お客様の声",
      signboards: "看板掲出",
      corporateProfile: "会社概要",
      careers: "採用情報",
      contact: "お問い合わせ",
    },
    common: {
      langLabel: "言語",
      switchToEn: "English",
      switchToJa: "日本語",
      open: "メニューを開く",
      close: "閉じる",
      learnMore: "詳しく見る",
      viewBusiness: "事業内容を見る",
      viewServices: "運営サービスを見る",
      viewProfile: "会社概要を見る",
      viewContact: "お問い合わせ",
      viewVision: "企業理念を見る",
      viewAllNews: "一覧を見る",
      independentService:
        "本サービスは独立したサービスであり、NEXCO・ETC利用照会・各種公式サービスではありません。",
      preparing: "準備中",
      back: "ホームへ戻る",
    },
    tooltips: {
      digitalInfrastructure:
        "モビリティ・記録・サポート・業務フローを、より分かりやすく管理するための実務的な仕組みです。",
      aiAssisted:
        "技術によって整理・確認を支援する仕組みです。人による判断や成果を保証するものではありません。",
      independentService:
        "NoJo Enterpriseのサービスは独立して運営されており、NEXCO、ETC利用照会、高速道路会社、銀行、政府機関の公式サービスではありません。",
      changeMoneyPlanned:
        "JapanChangeMoney.comは準備中の外貨両替サービスです。公開表現では、正式な開始・登録・金融機関・規制対象サービスであると誤解される表現を避けます。",
      pillarMobility:
        "日本のETC、道路、通行料金、車両関連の仕組みを、より分かりやすく利用できるよう支援する考え方です。",
      pillarRecords:
        "利用情報、通行記録、レポートを整理し、確認しやすく管理しやすい形へ整える考え方です。",
      pillarDigital:
        "現在のサービスと将来の展開を支える、システム・自動化・安全な業務フローのことです。",
    },
    home: {
      eyebrow: "NOJO ENTERPRISE / OFFICIAL CORPORATE SITE",
      taglineJa: "移動を支え、記録をつなぎ、信頼で社会を前へ。",
      headline1: "日本の実務課題を、",
      headline2: "信頼できるデジタル基盤へ。",
      heroNumber1: "日本全国",
      heroNumber1Label: "お客様基盤",
      heroNumber2: "2013年",
      heroNumber2Label: "横須賀から創業",
      heroNumber3: "JA / EN",
      heroNumber3Label: "完全バイリンガル運営",
      subcopy:
        "NoJo Enterpriseは、外国人居住者、米軍関係者、企業、官公庁、日本人ドライバーの方々が日本で直面する実務課題を、信頼できるデジタルサービスとして形にしている独立系企業です。",
      heroCtaPrimary: "運営サービスを見る",
      heroCtaSecondary: "事業内容",
      heroTilesLabel: "事業領域",
      heroTileMobility: "モビリティ",
      heroTileRecords: "記録・レポート",
      heroTileFinancial: "デジタル基盤",
      newsLabel: "お知らせ",
      newsDate: "2026.01",
      newsBodyJa: "公式コーポレートサイトのフェーズ2を公開しました。",
      newsBodyEn: "Phase 2 of the official corporate site is now live.",
      focusLabel: "CORPORATE FOCUS",
      focusBody: "日本の実務課題を、信頼できるデジタル基盤へ。",
      proofLabel: "現在の主要サービス領域",
      proofSupport: "NoJo Enterpriseの現在の主要サービス領域です。",
      proofEtc: "ETCカード",
      proofToll: "AI活用の通行記録",
      proofMoney: "外貨両替",
      pillarsLabel: "事業領域",
      pillarsTitle: "私たちが向き合う、4つの領域。",
      pillarsContextLabel: "3つの柱が示すもの",
      pillarsContextTitle: "Mobility · Records · Digital Infrastructure",
      pillarsContextBody:
        "NoJo Enterpriseは、モビリティ・記録・デジタル基盤という3つの柱を通じて、日本の実務課題を解決するサービスづくりに取り組んでいます。",
      pillarMobilityDef:
        "モビリティとは、日本の道路・ETC・車両利用に関する仕組みを、より分かりやすく、利用しやすく支えることです。",
      pillarRecordsDef:
        "記録とは、分散した利用情報を整理し、確認しやすく、管理しやすい形へ整えることです。",
      pillarDigitalDef:
        "デジタル基盤とは、モビリティ、記録管理、多言語サポート、将来のサービス展開を支えるシステム・自動化・安全な業務フローのことです。",
      audienceLabel: "私たちが支えるお客様",
      audienceTitle: "日本全国に広がる特定のお客様基盤。",
      audienceBody:
        "NoJo Enterpriseのサービスは、日本のモビリティ、通行記録、多言語サポートに関する実務課題に向き合ってきた経験から生まれています。テクノロジーだけではなく、現場のお客様と築いた信頼と運営知見が私たちの強みです。",
      flywheelLabel: "業務改善のサイクル",
      flywheelTitle: "お客様の不便から、次のサービスへ。",
      pillarMobilityTitle: "モビリティを支える",
      pillarMobilityBody:
        "ETC・道路インフラを支える独立サービスで、外国人ドライバーや法人利用者など、多様な利用者をサポートします。",
      pillarRecordsTitle: "記録とレポートを支援",
      pillarRecordsBody:
        "ETC利用記録の整理、レポート化、確認の効率化を支援。個人・法人・組織が記録を扱いやすい仕組みを提供します。",
      pillarFinancialTitle: "デジタル基盤を築く",
      pillarFinancialBody:
        "外貨両替関連の業務フロー、データ整理、自動化を組み合わせた、長く使えるデジタル基盤を実務目線で設計します。",
      pillarMultilingualTitle: "多言語でサポート",
      pillarMultilingualBody:
        "日本語と英語の両方でお客様をサポート。日本での生活・業務に必要な実務手続きを、わかりやすくご案内します。",
      brandsLabel: "運営サービス",
      brandsTitle: "NoJo Enterpriseが運営するサービス。",
      brandCategoryEtc: "ETCカード支援 / モビリティ",
      brandTitleEtc: "JapanETCcard.com",
      brandHeadlineEtc: "ETC利用を、もっとスムーズに。",
      brandSummaryEtc:
        "外国人ドライバー、外資系企業、米軍関係者など、日本でETCカードを必要とする方のための独立した支援サービス。",
      brandCategoryToll: "ETC利用記録の整理 / レポート",
      brandTitleToll: "JapanTollReceipts.jp",
      brandHeadlineToll: "ETC記録を、見える化・カンタンに。",
      brandSummaryToll:
        "個人・企業・フリート管理者・組織向けに、ETC利用記録の整理とレポート作成を支援する独立したサービス。",
      brandCategoryMoney: "外貨両替 (準備中)",
      brandTitleMoney: "JapanChangeMoney.com",
      brandHeadlineMoney: "送金・決済を、もっと便利に。",
      brandSummaryMoney:
        "透明性のあるレートと分かりやすい説明を重視した、準備中の外貨両替・金融サービス。",
      brandViewDetail: "サービス詳細を見る",
      aboutLabel: "NoJo Enterpriseについて",
      aboutTitle: "私たちは、信頼されるデジタルパートナーであり続けます。",
      aboutBody:
        "NoJo Enterpriseは、横須賀発の独立系デジタルサービス企業です。デジタル技術とインフラサービスを通じて、移動・記録・お金の流れを安全につなぎ、人々の暮らしとビジネスを支えます。",
      aboutCta: "会社概要・沿革を見る",
      techLabel: "テクノロジー",
      techTitle: "現場の課題を、使えるテクノロジーへ。",
      techBody:
        "ウェブシステム、自動化、データ整理、AI支援ワークフロー、セキュリティ設計を組み合わせ、実務で本当に役立つサービスを構築しています。",
      techLink: "技術アプローチを見る",
      trustLabel: "信頼とセキュリティ",
      trustTitle: "重要な情報は、安全な画面の中だけで。",
      trustBody:
        "通常のメールやチャットでの個人情報送信を求めない運用、最小限のデータ保持、ロールベースの内部アクセス、変更操作の監査ログ対応など、信頼を前提とした設計を行っています。",
      trustLink: "セキュリティ方針を見る",
      ctaTitle: "NoJo Enterpriseの事業について。",
      ctaBody:
        "会社概要、運営サービスの詳細、お問い合わせはこちらからご覧いただけます。",
      trustStrip: {
        trustFounded: "2013年創業",
        trustYokosuka: "横須賀発のデジタルサービス企業",
        trustBilingual: "日本語・英語対応",
        trustServices: "モビリティ・記録・デジタル基盤",
        trustOperational: "実務課題から生まれたサービス開発",
      },
    },
    placeholder: {
      eyebrow: "PHASE 02 / IN PREPARATION",
      heading: "このページは準備中です。",
      body:
        "NoJo Enterpriseの公式コーポレートサイトを段階的に公開しています。本ページの詳細コンテンツは順次公開予定です。",
    },
    pageTitles: {
      company: "会社情報",
      companyVision: "企業理念",
      companyMessage: "代表メッセージ",
      companyProfile: "会社概要",
      companyHistory: "沿革",
      business: "事業内容",
      services: "運営サービス",
      serviceEtcCard: "JapanETCcard.com",
      serviceTollReceipts: "JapanTollReceipts.jp",
      serviceChangeMoney: "JapanChangeMoney.com",
      technology: "テクノロジー",
      trustSecurity: "信頼とセキュリティ",
      news: "お知らせ",
      contact: "お問い合わせ",
    },
    pageDescriptions: {
      company:
        "株式会社NoJo Enterpriseの会社情報を、企業理念・代表メッセージ・会社概要・沿革に分けてご紹介します。",
      companyVision:
        "ミッション、ビジョン、バリュー、そしてモビリティ・記録・デジタル基盤の3領域モデルを通じて、NoJo Enterpriseの企業理念をご紹介します。",
      companyMessage:
        "代表メッセージは現在準備中です。サービス開発の背景と今後の方向性についてご案内予定です。",
      companyProfile:
        "株式会社NoJo Enterpriseの公式な会社概要、所在地、設立、資本金、事業領域を掲載予定のページです。",
      companyHistory:
        "2013年の創業以降の主な歩みを、年表形式でまとめて公開予定です。",
      business:
        "NoJo Enterpriseの事業領域 (モビリティ・記録・デジタル基盤・多言語サポート) を整理し、各領域の取り組みをご紹介予定です。",
      services:
        "JapanETCcard.com、JapanTollReceipts.jp、JapanChangeMoney.comの概要を一覧でご紹介予定です。",
      serviceEtcCard:
        "外国人ドライバー・法人利用者・米軍関係者など、日本でETCカードを必要とする方への独立した支援サービスです。詳細ページは準備中です。",
      serviceTollReceipts:
        "個人・企業・フリート管理者・組織向けに、ETC利用記録の整理とレポート作成を支援する独立したサービスです。詳細ページは準備中です。",
      serviceChangeMoney:
        "透明性のあるレートと分かりやすい説明を重視した、準備中の外貨両替サービスです。詳細ページは公開準備中です。",
      technology:
        "ウェブシステム、自動化、データ整理、AI支援ワークフロー、セキュリティ設計など、NoJo Enterpriseの技術的アプローチを紹介予定です。",
      trustSecurity:
        "重要な情報の取り扱い、ロールベースの内部アクセス、監査ログ、顧客への透明性通知など、信頼を支える設計を掲載予定です。",
      news:
        "コーポレート、サービス、セキュリティに関するお知らせを掲載予定です。",
      contact:
        "一般・法人・メディアからのお問い合わせフォームを準備中です。",
    },
    footer: {
      tagline:
        "ETCカード、通行記録の整理、外貨両替関連サービス、多言語サポートを通じて、日本の実務課題を解決するデジタル基盤づくりに取り組んでいます。",
      supportLine: "移動を支え、記録をつなぎ、信頼できるデジタル基盤を届けます。",
      rights: "All rights reserved.",
      preview: "プレビュー環境 (検索エンジン非公開)",
      sections: {
        company: "会社情報",
        services: "運営サービス",
        legal: "サイト",
      },
      independentNotice:
        "JapanETCcard.comおよびJapanTollReceipts.jpはNEXCO・ETC利用照会サービス・高速道路会社の公式サービスではありません。",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      whoWeServe: "Who We Serve",
      customers: "Who We Serve",
      approach: "Our Approach",
      ecosystem: "Ecosystem",
      whatsNew: "What's New",
      roadmap: "Roadmap",
      testimonials: "Testimonials",
      signboards: "Signboards",
      corporateProfile: "Corporate Profile",
      careers: "Careers",
      contact: "Contact",
    },
    navDesc: {},
    common: {
      langLabel: "Language",
      switchToEn: "English",
      switchToJa: "日本語",
      open: "Open menu",
      close: "Close",
      learnMore: "Learn more",
      viewBusiness: "View Business",
      viewServices: "View Services",
      viewProfile: "View Corporate Profile",
      viewContact: "Contact Us",
      viewVision: "View Vision",
      viewAllNews: "View all news",
      independentService:
        "This service is independent and is not affiliated with NEXCO or any toll-road operator's official service.",
      preparing: "In preparation",
      back: "Back to home",
    },
    tooltips: {
      digitalInfrastructure:
        "Practical systems that help people and organizations manage mobility, records, support, and service workflows more clearly.",
      aiAssisted:
        "Technology-supported organization and review. It does not replace human judgment or guarantee outcomes.",
      independentService:
        "NoJo Enterprise services are operated independently and are not official NEXCO, MEISAI, toll-road operator, bank, or government services.",
      changeMoneyPlanned:
        "JapanChangeMoney.com is a planned money exchange service. Public wording does not imply launch, licensing, banking, or regulated financial-service status unless specifically approved.",
      pillarMobility:
        "Helping people and organizations move through Japan's ETC, road, toll, and vehicle-related systems more clearly.",
      pillarRecords:
        "Organizing usage information, toll records, and reports into a format that is easier to review and manage.",
      pillarDigital:
        "The systems, automation, and secure workflows that support NoJo's current services and future expansion.",
    },
    home: {
      eyebrow: "NOJO ENTERPRISE / OFFICIAL CORPORATE SITE",
      taglineJa: "Supporting mobility. Connecting records. Securing trust.",
      headline1: "Solving Japan's practical pain points",
      headline2: "through trusted digital systems.",
      heroNumber1: "Nationwide",
      heroNumber1Label: "Focused customer base",
      heroNumber2: "Est. 2013",
      heroNumber2Label: "Founded in Yokosuka",
      heroNumber3: "JA / EN",
      heroNumber3Label: "Fully bilingual operations",
      subcopy:
        "NoJo Enterprise is an independent operator building trusted digital services for the foreign residents, U.S. military families, businesses, government users and Japanese drivers navigating Japan's everyday systems.",
      heroCtaPrimary: "View Services",
      heroCtaSecondary: "View Business",
      heroTilesLabel: "Business areas",
      heroTileMobility: "Mobility",
      heroTileRecords: "Records & Reports",
      heroTileFinancial: "Digital Infrastructure",
      newsLabel: "News",
      newsDate: "2026.01",
      newsBodyJa: "公式コーポレートサイトのフェーズ2を公開しました。",
      newsBodyEn: "Phase 2 of the official corporate site is now live.",
      focusLabel: "CORPORATE FOCUS",
      focusBody:
        "Solving Japan's practical pain points through trusted digital systems.",
      proofLabel: "CURRENT SERVICE AREAS",
      proofSupport:
        "Current service areas that support the broader NoJo Enterprise vision.",
      proofEtc: "ETC Cards",
      proofToll: "AI-Assisted Toll Receipts",
      proofMoney: "Money Exchange",
      pillarsLabel: "Business areas",
      pillarsTitle: "Four areas we focus on.",
      pillarsContextLabel: "What our pillars mean",
      pillarsContextTitle: "Mobility · Records · Digital Infrastructure",
      pillarsContextBody:
        "NoJo Enterprise uses Mobility, Records and Digital Infrastructure to describe the practical systems we are building around real problems in Japan.",
      pillarMobilityDef:
        "Mobility means helping people and organizations move through Japan's road and toll systems with clearer support, easier access and better service workflows.",
      pillarRecordsDef:
        "Records means turning fragmented usage information into organized, reviewable and easier-to-manage records.",
      pillarDigitalDef:
        "Digital Infrastructure means the systems, automation and secure workflows that connect mobility, records, customer support and future service expansion.",
      pillarMobilityTitle: "Supporting mobility",
      pillarMobilityBody:
        "Independent services around ETC and Japan's expressway infrastructure — accessible to foreign drivers, corporate users and international customers.",
      pillarRecordsTitle: "Records & reporting",
      pillarRecordsBody:
        "Helping individuals, businesses, fleet managers, and organizations organize ETC usage records and review toll activity efficiently.",
      pillarFinancialTitle: "Building digital infrastructure",
      pillarFinancialBody:
        "Exchange-related workflows, data organization and automation combined into long-lasting digital infrastructure designed from real operational needs.",
      pillarMultilingualTitle: "Multilingual support",
      pillarMultilingualBody:
        "Practical Japanese and English customer support for everyday administrative procedures, ETC questions and service onboarding.",
      brandsLabel: "Operated Services",
      brandsTitle: "Services operated by NoJo Enterprise.",
      brandCategoryEtc: "ETC card support / Mobility",
      brandTitleEtc: "JapanETCcard.com",
      brandHeadlineEtc: "Smoother ETC access in Japan.",
      brandSummaryEtc:
        "Independent support service for international drivers, foreign residents, businesses and military-connected customers who need practical help with ETC-card related services.",
      brandCategoryToll: "Toll-record automation / Reporting",
      brandTitleToll: "JapanTollReceipts.jp",
      brandHeadlineToll: "Clearer ETC usage records.",
      brandSummaryToll:
        "Independent service that helps individuals, companies, fleet managers and organizations organize ETC usage records and receive clearer toll reports.",
      brandCategoryMoney: "Money Exchange / Planned",
      brandTitleMoney: "JapanChangeMoney.com",
      brandHeadlineMoney: "Clearer money exchange experience.",
      brandSummaryMoney:
        "A planned money-exchange service focused on transparent rates, customer education and compliance-aware workflows.",
      brandViewDetail: "View service detail",
      aboutLabel: "About NoJo Enterprise",
      aboutTitle: "A trusted digital infrastructure partner for Japan's mobility, records and exchange-related flows.",
      aboutBody:
        "Headquartered in Yokosuka, NoJo Enterprise is an independent digital infrastructure company. Through digital technology and infrastructure-adjacent services, we safely connect mobility, records and exchange-related flows — supporting daily life and business in Japan.",
      aboutCta: "View corporate profile",
      techLabel: "Technology",
      techTitle: "Real-world problems, met with usable technology.",
      techBody:
        "Web systems, automation, data organization, AI-assisted workflows and security-conscious design — combined to build services that actually help operators on the ground.",
      techLink: "View our technology approach",
      trustLabel: "Trust & Security",
      trustTitle: "Important information stays inside secure screens.",
      trustBody:
        "We don't ask customers to send sensitive information by ordinary email or chat. Minimal data retention, role-based internal access and audit-log-ready mutations are part of our default operating posture.",
      trustLink: "View our security approach",
      ctaTitle: "Learn more about NoJo Enterprise.",
      ctaBody:
        "Corporate profile, operated services and contact channels are all available from here.",
      trustStrip: {
        trustFounded: "Founded in 2013",
        trustYokosuka: "Based in Yokosuka, Japan",
        trustBilingual: "Japanese and English support",
        trustServices: "Mobility, records, and digital infrastructure",
        trustOperational: "Practical services built from real operational problems",
      },
    },
    placeholder: {
      eyebrow: "PHASE 02 / IN PREPARATION",
      heading: "This page is in preparation.",
      body:
        "The NoJo Enterprise corporate website is being released in phases. The full content for this page will be published soon.",
    },
    pageTitles: {
      company: "Company",
      companyVision: "Vision",
      companyMessage: "Representative Message",
      companyProfile: "Corporate Profile",
      companyHistory: "History",
      business: "Business",
      services: "Services",
      serviceEtcCard: "JapanETCcard.com",
      serviceTollReceipts: "JapanTollReceipts.jp",
      serviceChangeMoney: "JapanChangeMoney.com",
      technology: "Technology",
      trustSecurity: "Trust & Security",
      news: "News",
      contact: "Contact",
    },
    pageDescriptions: {
      company:
        "An overview of NoJo Enterprise Co., Ltd. across vision, representative message, corporate profile and company history.",
      companyVision:
        "Mission, vision, values, and the purple/green/blue business-pillar system that shapes NoJo Enterprise's work.",
      companyMessage:
        "The representative message will explain the background of NoJo Enterprise's service development and future direction.",
      companyProfile:
        "Official corporate profile, location, founding date, capital and business categories for NoJo Enterprise Co., Ltd. — coming soon.",
      companyHistory:
        "A clean corporate timeline of major milestones since the company was founded in 2013.",
      business:
        "An organized view of NoJo Enterprise's business areas — mobility, records, digital infrastructure and multilingual support.",
      services:
        "Overview of the services operated by NoJo Enterprise: JapanETCcard.com, JapanTollReceipts.jp and JapanChangeMoney.com.",
      serviceEtcCard:
        "Independent ETC-card support service for international drivers, businesses and military-connected customers in Japan. Detailed page coming soon.",
      serviceTollReceipts:
        "Independent service that organizes ETC usage records and reports for individuals, businesses, fleet managers and organizations. Detailed page coming soon.",
      serviceChangeMoney:
        "Planned money-exchange service focused on transparent rates and clear customer education. Detailed page coming soon.",
      technology:
        "An overview of the technical approach behind NoJo Enterprise: web systems, automation, data organization, AI-assisted workflows and security design.",
      trustSecurity:
        "Trust, security and transparency commitments — including handling of sensitive information, role-based access, audit-log readiness and customer notifications.",
      news:
        "Corporate, service and security announcements will be published here.",
      contact:
        "A rate-limited contact form for general, partnership and media inquiries is in preparation.",
    },
    footer: {
      tagline:
        "Practical digital infrastructure for ETC cards, toll-record organization, exchange-related access, and multilingual support in Japan.",
      supportLine:
        "Supporting mobility. Connecting records. Building trusted digital infrastructure.",
      rights: "All rights reserved.",
      preview: "Preview environment (noindex)",
      sections: {
        company: "Company",
        services: "Services",
        legal: "Site",
      },
      independentNotice:
        "JapanETCcard.com and JapanTollReceipts.jp are independent services and are not affiliated with NEXCO or any toll-road operator's official service.",
    },
  },
};

export function t(lang, path) {
  const parts = path.split(".");
  let node = messages[lang] || messages.ja;
  for (const p of parts) {
    if (node && typeof node === "object" && p in node) {
      node = node[p];
    } else {
      return path;
    }
  }
  return node;
}
